var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HtmlReader',{attrs:{"id":"castle-conceptbooth"}}),_c('TitleLogo',{attrs:{"title":_vm.productType === 'premium' ? '프리미엄 컨셉 보기' : '메이커샷 컨셉 보기'}}),_c('v-sheet',[_c('ConceptBooth',{attrs:{"productType":_vm.productType}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }